<template>
	<div class="investmentClues">
		<leftnav class="fl" :mkcode="curWebsite.type == 5 || curWebsite.type == 6 ?'T':'C'" itemcode="C-QYTZCK"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
			<freeUserTips :type="4" :bgtype="0"></freeUserTips>
		</el-dialog>
			<div class="index_left_centerpage">
				<!-- 头部盒子开始 -->
				<div class="whitebox right_topbox">
					<div class="right_boxtitle" v-if="userdata.zsdn_version == 2">
						<span class="fl right_title" v-if="curWebsite.type != 5 && curWebsite.type != 6">{{curWebsite.keyword}}{{curWebsite.type == 2 ?'':'线索'}}</span>
						<span class="fl right_title" v-if="curWebsite.type == 5 || curWebsite.type == 6">{{curWebsite.type == 5 ? '投资':"产业"}}动态</span>
						<cluetips v-if="curWebsite.type != 5 && curWebsite.type != 6"></cluetips>
						<video-teaching :type="3" seat="top"></video-teaching>
					</div>
					<div class="right_boxtitle" v-if="userdata.zsdn_version == 1">
						<span class="fl right_title">从投资窗口期找企业</span>
						<p class="fl titlefont">哪些企业更有可能会投资？<br>答：处于高速增长的企业、获得大额融资的企业、准备上市的企业，投资的可能性更高。</p> 
					</div>
					<!-- 筛选项开始 -->
					<div class="opport-screen-list1">
						<div class="spage-searchbox "> 
							<ClueNav tabCode="qytzck" v-if="curWebsite.type != 5 && curWebsite.type != 6 && userdata.zsdn_version == 2"></ClueNav>  
							<dynamicNavTZ code="qytzck" v-if="curWebsite.type == 5 || curWebsite.type == 6"></dynamicNavTZ> 
							<dl class="opport-screen bdbe">
								<dt class="fl">企业类型</dt>
								<dd class="fl">
									<span v-for="(list,i) in screenType" :key="i"
										:class="eiwtype == list.type?'a-screen current':'a-screen'"
										@click="toggleIwtype(list)">{{list.name}}</span>
										<el-tooltip class="item smartTip-text" effect="light" placement="right-start"><i	class="el-icon-question listeltootipicon"></i>
											<div slot="content" class="list_tips">
												<p>高增长企业：营收增速和净利增速均大于等于50%，且营业收入大于等于10亿元的企业</p>
												<p>大额融资企业：末次融资金额大于等于1亿元，且处于扩张期的企业</p>
												<p>拟上市辅导备案企业：已做好上市准备企业</p>
												<!-- <p>新产品入市企业：有新产品进入市场的企业</p> -->
											</div>
										</el-tooltip>
								</dd>
							</dl>
							<finacingTime v-on:chooseFinancing="getEnterpriseList2" v-show="eiwtype == 2"></finacingTime> 
							<!-- 省市区筛选 -->
							<cityScreen  @getEnterpriseList="cityScreenFun" :isShowCounty="false"></cityScreen> 
						</div>
					</div>
					<!-- 筛选项结束 -->
				</div>
				<!-- 头部盒子结束 -->
				<!-- 表格内容开始 -->
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" >产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p> 
					</div>
					<div class="enterprise_list_box" style="padding-top: 20px;">
						<!-- 高增长企业 eiwtype=1 优质上市公司线索标头-->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="eiwtype == 1">
							<tr> 
							<th>序号</th>
							<th>行业名称</th>
							<th>营业收入（亿元）<i :class="order!=1 ? 'sort_ico' : 'sort_ico_up'" @click="getEnterpriseList1(1)"></i></th>
							<th>营收增速<i  :class="order!=2 ? 'sort_ico' : 'sort_ico_up'" @click="getEnterpriseList1(2)"></i></th>
							<th>净利润（亿元）<i  :class="order!=3 ? 'sort_ico' : 'sort_ico_up'" @click="getEnterpriseList1(3)"></i></th>
							<th>净利增速 <i  :class="order!=4 ? 'sort_ico' : 'sort_ico_up'" @click="getEnterpriseList1(4)"></i></th>
							<th style="width: 120px;">编辑</th>
							</tr> 
							<tr v-for=" (list,i) in  enterpristlist1" :key="'enterprise'+i"> 
							<td>{{(page-1)*pageSize+i+1}}</td>
								<td class="title"  @click="routerlinkid('/enterprises',list.stockCode,2,'','all')" >{{list.title}}</td>
								<td>{{list.lR0003}}</td>
								<td>{{list.lR0003Grow}}%</td>
								<td>{{list.lR0001}}</td>     
								<td>{{list.lR0001Grow}}%</td> 
								<td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td>
							</tr>
						</table>
						<!-- 大额融资企业 eiwtype=2 创新企业表头--> 
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="eiwtype == 2" >
							<tr>
								<th>序号</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>  
								<th>融资轮次</th>
								<th>融资时间</th>
								<th>融资金额</th>
								<th>地区</th>
								<th>投资方</th>
								<th>编辑</th>
								</tr> 
							<tr v-for="(list,index) in enterpristlist2" :key="'enterpri'+index">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td class="title"  @click="routerlinkid('/enterprises',list.stockCode,searchtype,'',searchtype)">{{list.title}}</td>
								<td class="conpanytags hastag1" v-show="list.notion!=''">
										<span class="span-tag" v-for="(item,i) in list.notionlist" :key="'notion'+i"  @click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name)">{{item.name}}</span> 
								</td> 
								<td class="conpanytags" v-show="list.notion==''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td> 
								<td class="conpanytags hastag1" v-show="list.tag!=''" > 
										<span class="span-tag" v-for="(item,i) in list.taglist"  :key="'tag'+i"  @click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name)">{{item.name}}</span> 
								</td> 
								<td class="conpanytags" v-show="list.tag==''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td>  
								<td>{{list.financingRound[0].rount}}</td> 
								<td>{{list.financingRound[0].time}}</td> 
								<td>{{list.financingRound[0].amount}}</td>  
								<td>{{list.area}}</td>
								<td class="orglist " >
									<p v-if="list.financingRound[0].id!='none'">
										<span v-for="(org,inds) in list.financingRound[0].orgList" :key="org.id" data="org.id" :class="org.id!=0?'curp':''" @click="routerlinkid('investement-enterprises',org.id)">{{org.orgName}}<i v-if="inds!=list.financingRound[0].orgList.length-1">、</i></span>
										</p>
									<p v-if="list.financingRound[0].id=='none'">-</p>
									</td>
									<td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td>
							</tr>
						</table>
						<!-- 拟上市辅导备案企业 eiwtype=3 全部企业去掉企业实力-->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="eiwtype == 3" >
							<tr>
								<th>序号</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<!-- <th>企业实力</th> -->
								<th>编辑</th>
							</tr> 
							<tr v-for="(list,index) in enterpristlist3" :key="index">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td class="title" @click="routerlinkid('/enterprises',list.stockCode,curindex)">{{list.title}}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="(item,i) in list.notionlist" :key="'F'+i" @click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name)">{{item.name}}</span>
								</td>
								<td class="conpanytags notiontags">
									<span class="span-tag" v-for="(item,i) in list.taglist" :key="'S'+i" @click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name)">{{item.name}}</span>
								</td>
								<td>{{list.area}}</td>
								<!-- <td>{{list.zs100000}}</td> -->
								<td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td>
							</tr>
						</table>
						<!--  新产品入市企业 eiwtype=4 全部企业去掉企业实力-->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="eiwtype == 4" >
							<tr>
								<th>序号</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<!-- <th>企业实力</th> -->
								<th>编辑</th>
							</tr> 
							<tr v-for="(list,index) in enterpristlist4" :key="'enter'+index">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td class="title" @click="routerlinkid('/enterprises',list.stockCode,curindex)">{{list.title}}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="(item,i) in list.notionlist" :key="'T'+i" @click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name)">{{item.name}}</span>
								</td>
								<td class="conpanytags notiontags">
									<span class="span-tag" v-for="(item,i) in list.taglist" :key="'N'+i" @click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name)">{{item.name}}</span>
								</td>
								<td>{{list.area}}</td>
								<!-- <td>{{list.zs100000}}</td> -->
								<td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td>
							</tr>
						</table>
						
					</div>
					<!-- 表格内容结束 -->
					<div class="centerpage1 company_pagelist nojump" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div> 
</template>

<script>
	// import { dataInJs } from "../../utils/city.js";
	import {
		dataInJs
	} from "../../utils/city.js";
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'enterpriseInvestmentWindow',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				title: "企业投资窗口",
				userdata:{},curWebsite:this.$api.getWebsiteType(),  
				searchtype: 10, //线索类型 2以商招商 1本省投资概率 3关键融资 4优质企业  
				eiwtype:1,
				screenType: [{
						name: "高增长企业",
						type: 1
					},
					{
						name: "大额融资企业",
						type: 2
					},
					{
						name: "拟上市辅导备案企业",
						type: 3
					},
					// {
					// 	name: "新产品入市企业",
					// 	type: 4
					// },
				],
				enterpristlist1:[],sort:0,enterpristlist2:[],enterpristlist3:[],enterpristlist4:[], 
				finantime:'',order:0,
				enterpristlist: [],
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 100, //记录总数 
				totalPage: 1,
				maxPage: 10, //最大页数 
				provinceid: 0,
				cityid: 0,
				countyid: 0,
				provincedata: dataInJs(),
				zhixiaCitydata: [11,12,50,31],
				citydata: [],
				countydata: [],
				isShowFreeUserTips: false,
			}
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键 // 禁用选择
				document.oncontextmenu = new Function("event.returnValue=false"); 
				document.onselectstart = new Function("event.returnValue=false");
			});
			var _this = this;
			this.userdata = this.getuseriformation(); 
			// this.getcompanylist();
		},
		mounted() {
			document.getElementById('app').style.background = "#f0f3f5";
			this.getConpanyList();
		},
		methods: { 
			cityScreenFun(pid,cid,cuid){ 
				this.cityid = cid;
				this.countyid = cuid; 
				this.provinceid = pid;
				this.getConpanyList(1);
			}, 
			//企业类型切换
			toggleIwtype(data) {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				this.eiwtype = data.type; 
				this.getConpanyList(1);
			}, 
			//高增长企业列表获取 
			getEnterpriseList1(order){
				this.order=order;
				console.log(order)
				this.getConpanyList();
			},
			//大额融资企业
			getEnterpriseList2(time1){
				 this.finantime=time1 == 'year' ? '' : time1;
					this.getConpanyList(1);
			},
			//高增长企业列表获取
			getEnterpriseList3(){
				 
			},
			getConpanyList(page){
				this.bus.$emit('loading', true);  
				this.page=page?page:this.page;
				// var countyidja =this.splicing('county',this.countyid);
				// var provinceidja =this.splicing('province',this.provinceid);
				var provinceidja ='&province='+this.provinceid;
				var cityidja ='&city='+this.cityid;
				// var cityidja =this.splicing('city',this.cityid); 
				var timeja = this.eiwtype == 2 ? this.splicing('time',this.finantime) :''; 
				var orderja=this.eiwtype == 1 ? this.splicing('order',this.order) :'';
				var pageja= this.splicing('page',this.page) ;
				var ajaxurl=this.$api.cyl.investclue.EnterpriseInvestmentWindow()+'?entType='+this.eiwtype+timeja+orderja+pageja+provinceidja+cityidja;
				// var ajaxurl=this.$api.cyl.investclue.EnterpriseInvestmentWindow()+'?entType=1&province=0&city=0&order=3&page=1';

				console.log(ajaxurl)
				var _this=this;
				
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) { 
					if (res.data.success) {
						_this.bus.$emit('loading', true);  
						var dataenterlist= res.data.list;
						console.log(_this.eiwtype, res.data); 
						if(_this.eiwtype>1){
							for (var i = 0; i < res.data.list.length; i++) {
								dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[i].notionCode,'notionsort');
								dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i].tagCode);  
							}
						}
						if(_this.eiwtype == 1){
							_this.enterpristlist1=dataenterlist;
						}else if(_this.eiwtype == 2){ 
							_this.enterpristlist2=dataenterlist;
						}else if(_this.eiwtype == 3){  
							_this.enterpristlist3=dataenterlist; 
						}else if(_this.eiwtype == 4){
							_this.enterpristlist4=dataenterlist; 
						}
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord; 
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {}); 
				
				
				if(this.eiwtype == 1){
					
				}else if(this.eiwtype == 2){
					
					
				}else if(this.eiwtype == 3){
				 
				}
				
				
				
			},
			pageHandler: function(page) {
				// console.log('pageHandler',this.userdata.groupType==0,page > 2)
				if (this.userdata.groupType == 0 && page > 2) {
					this.bus.$emit('tipspop', {
						lock: true,
						type: "permission"
					});
				} else {
					this.getConpanyList(page);
				}
			},
			//省份城市选择
			provincechoose(id, i) {
				this.provinceid = id;
				this.cityid = 0;
				this.countyid = 0;
				this.countydata = [];
				if (i != "all" && this.provincedata[i].children != null) {
					this.citydata = this.provincedata[i].children;
				} else {
					this.citydata = [];
				}
				this.page = 1;
				this.getConpanyList();
			},
			choosecity(id, i) {
				//	console.log('choosecity',id);
				this.cityid = id;
				this.countyid = 0;
				if (i != "all" && this.citydata[i].children != null) {
					this.countydata = this.citydata[i].children;
				} else {
					this.countydata = [];
				}
				this.page = 1;
				this.getConpanyList();
			},
			choosecounty(id) {
				//	console.log('choosecity',id);
				this.countyid = id;
				this.page = 1;
				this.getConpanyList();
			}, 
			 
		},
	}
</script>

<style>
	/* 提示框箭头 */
	.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
		border-top-color: #E0E8F9;
	}

	.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
		border-top-color: #E0E8F9;
	}

	/* 提示框背景色 */
	.atooltip {
		background: #E0E8F9 !important;
	}


	.a-red {
		color: #c00;
	}

	.nojump .jump {
		display: none;
	}
</style>
